class TKCDesktopCategoryDrawer {
  constructor() {
    this.drawer = document.querySelector("#tkc-desktop-category-drawer");
    if (!this.drawer) return;

    this.panel = this.drawer.querySelector(".tkc-category-drawer__panel");
    this.closeButtons = this.drawer.querySelectorAll("[data-tkc-category-close]");
    this.buttons = document.querySelectorAll("[data-tkc-category-open]");
    this.toggles = this.drawer.querySelectorAll(".tkc-category-drawer__toggle");
    this.desktopHeader = document.querySelector(".m-header__desktop");

    this.bind();
    this.updateTop();
    window.addEventListener("resize", () => this.updateTop());
    window.addEventListener("scroll", () => {
      if (this.drawer.classList.contains("is-open")) this.updateTop();
    }, { passive: true });
  }

  bind() {
    this.buttons.forEach((button) => {
      button.addEventListener("click", () => this.toggle());
    });

    this.closeButtons.forEach((button) => {
      button.addEventListener("click", () => this.close());
    });

    this.toggles.forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const submenu = toggle.closest(".tkc-category-drawer__item-row")?.nextElementSibling;
        if (!submenu) return;

        const expanded = toggle.getAttribute("aria-expanded") === "true";
        toggle.setAttribute("aria-expanded", String(!expanded));
        submenu.hidden = expanded;
        toggle.classList.toggle("is-open", !expanded);
      });
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && this.drawer.classList.contains("is-open")) {
        this.close();
      }
    });
  }

  updateTop() {
    if (!this.desktopHeader) return;
    const rect = this.desktopHeader.getBoundingClientRect();
    const top = Math.max(0, Math.round(rect.bottom));
    this.drawer.style.setProperty("--tkc-category-drawer-top", `${top}px`);
  }

  toggle() {
    if (this.drawer.classList.contains("is-open")) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.updateTop();
    this.drawer.classList.add("is-open");
    this.drawer.setAttribute("aria-hidden", "false");
    this.buttons.forEach((button) => button.setAttribute("aria-expanded", "true"));
    document.documentElement.classList.add("tkc-category-drawer-open");
    const firstClose = this.drawer.querySelector(".tkc-category-drawer__close");
    firstClose && firstClose.focus();
  }

  close() {
    this.drawer.classList.remove("is-open");
    this.drawer.setAttribute("aria-hidden", "true");
    this.buttons.forEach((button) => button.setAttribute("aria-expanded", "false"));
    document.documentElement.classList.remove("tkc-category-drawer-open");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new TKCDesktopCategoryDrawer();
});
